import { HttpParams } from '@angular/common/http';

/**
 * Builds HttpParams by converting all values to arrays and handling them uniformly.
 * Single values are converted to single-item arrays.
 * Multiple values for the same parameter are appended to the URL.
 */
export function buildHttpParams(
  params: Record<string, string | string[] | number | boolean | null | undefined>
): HttpParams {
  let httpParams = new HttpParams();
  
  if (!params) {
    return httpParams;
  }

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined) {
      return;
    }

    // Convert any value to array
    const values = Array.isArray(value) ? value : [value];
    
    // Append each value
    values.forEach(item => {
      httpParams = httpParams.append(key, item.toString());
    });
  });

  return httpParams;
} 